import React, { useState, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import format from 'date-fns/format';
import { makeStyles, fade } from '@material-ui/core/styles';
import { notificationCenterWidth, RightSideBarWidth } from '../../../styleVariables';
import useMountEffect from '../../../mountEffect';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import * as logger from "../../../logger";
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import { connect } from 'react-redux';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import {
  updateChatView, toggleChatSupport, onlinePaymentsConfig
} from "../../../store/actions/userActionCreators";
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { freshChat } from '../../../configs/configs';
import FreshChat from 'react-freshchat';
import MobileStepper from '@material-ui/core/MobileStepper';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { biltyContinueClick } from '../../../store/actions/tripActionCreator';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ExcelIcon, PdfIconWhite } from '../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { getDriverLedgerV2 } from '../../../store/actions/homeActionCreator';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObject } from '../../../utils/utils';
import { RightArrow } from '../TopCard/icons';
import Highlighter from "react-highlight-words";
import { Form } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import AmountInput from '../Inputs/AmountInput';
import { InputAdornment } from '@material-ui/core';
import TextInputState from '../Inputs/TextInputState';
import { getBankDetails, getPaymentLink,getPaymentInitiate } from '../../../store/actions/OnlinePaymentActionCreators';
import AddIcon from '@material-ui/icons/Add';
import AddBankDetailsDialog from '../Bank/AddBankDetailsDialog';
import SuccessDialog from '../Verfication/SuccessDialog';
import FailureDialog from '../Verfication/FailureDialog';
import BankDetailsSelectionDialog from '../Bank/BankDetailsSelectionDialog';
import { VerifiedBankAccount, UnVerifiedBankAccount } from '../TopCard/icons';
import { trackDwebEvent } from '../../analytics';
import AddPhoneNumberDialog from '../Dialog/AddPhoneNumberDialog';
import { getUserDetails } from '../../../store/actions/authActionCreators';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import DwebPaymentGateWayDialog from '../Dialog/DwebPaymentGateWayDialog';

import { Box } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  transactionDetailsDrawer: {
    width: 538,
    maxWidth: 538,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  backdrop: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    }
  },
  container: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1,
    flexGrow: 1
  },
  sideBarDialogContentV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    backgroundColor: '#f6f6f8'
  },
  divTitle: {
    display: 'flex',
    alignItems: 'center',
    color: "#0b1323",
    fontSize: 18,
    marginBottom: 4
  },
  divSecTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: "rgba(11, 19, 35, 0.75);",
    marginBottom: 8
  },
  titleDiv: {
    display: 'flex',
    flexDirection: 'column'
  },
  search: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fff",
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    border: "solid 1px rgba(11, 19, 35, 0.5)",
    marginRight: 0,
    marginLeft: 0,
    width: '100%',
  },
  sicon: {
    fontSize: 18
  },
  searchIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    padding: "0px 12px",
    height: '100%',
    color: "rgba(11, 19, 35, 0.75)",
    //position: 'absolute',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    fontSize: 14,
    padding: "9px 0px",
    //paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    width: '100%'
  },
  sideBarActions: {
    paddingTop: 24,
    paddingBottom: '24px !important',
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: 'white'
  },
  subTitleSec: {
    marginBottom: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  bankSubTitleSec: {
    marginBottom: 2,
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:last-child': {
      marginBottom: 0
    }
  },
  listingDiv: {
    marginTop: 24
  },
  subTitleTxt: {
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(11, 19, 35, 0.5)"
  },
  driverDiv: {
    padding: 16,
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    //transition:'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    marginBottom: 12,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'cente',
    justifyContent: 'space-between'
  },
  nameDiv: {
    display: 'flex',
    flexDirection: 'column',
    //alignItems:'center',
    fontSize: 16
  },
  bankValueDiv: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 16
  },
  balanceDiv: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },
  listDriverBalance: {
    fontWeight: 600
  },
  listDriverBalancePositive: {
    fontWeight: 600,
    color: "#379953"
  },
  listDriverBalanceNegative: {
    fontWeight: 600,
    color: "#ff0000"
  },
  listDriverBalanceZero: {
    fontWeight: 600,
    color: "#0b1323"
  },
  highlight: {
    color: "#1860f0",
    padding: 0
  },
  driverDetailsDiv: {
    padding: "16px 24px",
    borderRadius: 8,
    border: "solid 1px #dcdcdc",
    backgroundColor: " #ededed",
    marginBottom: 24,
    marginTop: 2
  },
  bankDetailsDiv: {
    padding: 16,
    borderRadius: 8,
    backgroundColor: " #fff",
    marginBottom: 24,
    marginTop: 2
  },
  infoDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  titleV2: {
    fontSize: 14,
    fontWeight: 600,
    color: '#6b778c',
    marginBottom: 4
  },
  newInput: {
    backgroundColor: '#fff',
    paddingLeft: 16,
    border: "solid 1px #dedede",
    "& .MuiInputBase-input": {
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 0
    }
  },
  changeButton: {
    padding: "8px 16px",
    borderRadius: 8,
    border: "solid 1px #f1f1f1",
    backgroundColor: " #0033cc",
    fontSize: 12,
    fontWeight: 600,
    color: "#fff",
    "&:hover": {
      backgroundColor: " #0033cc",
    }
  },
  addBankDetailsButton: {
    padding: "12px 16px 12px 12px",
    borderRadius: 4,
    border: "solid 1px #0033cc",
    backgroundColor: "#0033cc",
    fontSize: 16,
    fontWeight: 600,
    color: "#fff",
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#0033cc",
    }
  },
  verifiedAccount: {
    fontSize: 12,
    color: "rgba(21, 128, 38, 0.6)"
  },
  unVerifiedAccount: {
    fontSize: 12,
    color: "#e93333"
  },
  valueTxt: {
    textTransform: 'capitalize',
    fontWeight: 600
  },
  valueTxt1: {
    textTransform: 'capitalize',
  },
  alignEnd: {
    textAlign: 'end'
  },
  payNowButton: {
    marginLeft: 16,
    padding: '6px 30px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#09101e',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: "#09101e",
    }
  },
  balance: {
    color: "rgba(11, 19, 35, 0.75)",
    fontSize: 12,
    paddingLeft: 8,
    textTransform: 'uppercase'
  },
  driverName: {
    fontSize: 12
  },
  emptyStateDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  emptyTxt: {
    color: "#787878",
    marginTop: 32,
    textAlign: 'center'
  },
  addCta: {
    backgroundColor: "#0033cc",
    textTransform: "uppercase",
    fontWeight: 600,
    color: '#fff',
    paddingTop: 17,
    paddingBottom: 17,
    borderRadius: 8,
    width: '100%',
    '&:hover': {
      backgroundColor: "#0033cc",
    }
  }
}));

const PayDriverSideBar = ({
  rightSideBarOpen,
  toggleRightSideBar,
  user,
  defaultData,
  fromSingleDriver,
  children,
  sideBarName,
  sideBarTitle,
  sideBarSecondaryTitle,
  handleSubmit,
  dispatchChatView,
  dispatchFetchAllDrivers,
  dispatchFetchBankDetails,
  dispatchGetPaymentLink,
  dispatchGetUserDetails,
  dispatchGetOnlinePaymentsConfig,
  dispatchGetPaymentInitiate
}) => {
  let submit, formValues;
  const classes = useStyles();
  const [updateChatView, setChatView] = useState(false);
  const [progress, setProgress] = useState(25);
  const [successCreation, setSuccessCreation] = useState(false);
  const [failureCreation, setFailureCreation] = useState(false);
  const [driverSearchTxt, setDriverSearchTxt] = useState("");
  const [selectedDriver, setSelectedDriver] = useState(null);
  /**Drivers Data Fetching */
  const [driverLedgerData, setDriverLedgerData] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [addBankDetails, setAddBankDetails] = useState(false)
  const [selectBank, setSelectBank] = useState(false)
  const [amount, setAmount] = useState(null);
  const [reason, setReason] = useState(null);
  const [addPhoneNumber, setAddPhoneNumber] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [configInfo, setConfigInfo] = useState({});
  const [addDriverOpen, setAddDriverOpen] = React.useState(false);
  const [recall, setRecall] = React.useState(false);

  //Payment GateWay
  const [customPGOpen, setCustomPGOpen] = useState(false);
  const [cashFreeOrderData,setCashFreeOrderData] = useState(null);
  const [orderRequestData,setOrderRequestData] = useState(null);
  const driverLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    // pageNo: 1,
    // pageSize: 10,
  };

  useEffect(() => {

    if (user && user.onlinePaymentConfig) {
      setConfigInfo(user.onlinePaymentConfig);
    } else {
      setConfigInfo({});
    }

  }, [user.onlinePaymentConfig]);

  useEffect(() => {

    if (user && user.userInfoProfile) {
      setUserInfo(user.userInfoProfile);
    }

  }, [user.userInfoProfile]);

  useEffect(() => dispatchFetchAllDrivers(driverLedgerRequestData,
    () => {
      logger.log("Drivers dWeb", "Fetch all drivers successfull");
      trackDwebEvent('Dweb Online Payments driver listing page', {});
    },
    () => {
      logger.log("Drivers dWeb", "Fetch all drivers failed");
    }
  ), [
    dispatchFetchAllDrivers,
    recall
  ]);
  const handleAddDriverClose = () => {
    setAddDriverOpen(false);
  };
  const handleAddDriverOpen = () => {
    setAddDriverOpen(true);
  };
  const handleDriverSave = (status, response) => {
    setAddDriverOpen(false);
    setRecall(!recall)
  }
  useEffect(() => {
    if (user.driverLedgerData && user.driverLedgerData.driverLedgerDataResponse) {
      setDriverLedgerData(user.driverLedgerData.driverLedgerDataResponse);
      // if (fromSingleDriver) {
      //   let driver = findArrayObject("id", defaultData.id, user.driverLedgerData.driverLedgerDataResponse);
      //   if (driver && driver.id) {
      //     setAmount(defaultData.amount ? defaultData.amount : null)
      //     handleDriverSelect(driver)
      //   }
      // } else
      if ((defaultData && defaultData.entityType && defaultData.entityId) || fromSingleDriver) {

        let driver;
        if (fromSingleDriver) {
          driver = findArrayObject("id", defaultData.id, user.driverLedgerData.driverLedgerDataResponse);
        } else {
          driver = findArrayObject("id", defaultData.entityId, user.driverLedgerData.driverLedgerDataResponse);
        }

        if (driver && driver.id) {
          setAmount(defaultData.amount ? defaultData.amount : null)
          handleDriverSelect(driver)
        }
      }
    }
  }, [user.driverLedgerData]);
  /**Drivers Data Fetching */


  useEffect(() => {
    dispatchChatView(false);
  }, []);

  const loadBanKList = () => {
    if (selectedDriver && selectedDriver.id) {
      let reqData = {
        type: "DRIVER",
        id: selectedDriver.id
      }
      dispatchFetchBankDetails(reqData, (response) => {
        if (response && response.status && response.status.code == 200 && response.response && response.response.length > 0) {
          setBankList(response.response)
        }
      }, () => {

      })
    }
  }

  const handleClose = () => {


    dispatchChatView(true);

    let finalBank = bankList.filter(v => v && v.is_default);

    const entityData = {
      driverId: selectedDriver && selectedDriver.id ? selectedDriver.id : "",
      driverName: selectedDriver && selectedDriver.name ? selectedDriver.name : "",
      driverBalance: selectedDriver && selectedDriver.driverBalance ? selectedDriver.driverBalance : "",
      driverPayoutAmount: amount ? amount : "",
      driverPayoutReason: reason ? reason : "",
      bankAccountId: finalBank && finalBank[0] && finalBank[0].id ? finalBank[0].id : ""
    }

    if (selectedDriver) {
      trackDwebEvent('Dweb Driver payout form page cancelled', {
        driver_id: selectedDriver && selectedDriver.id ? selectedDriver.id : "",
        driver_name: selectedDriver && selectedDriver.name ? selectedDriver.name : "",
        driver_balance: selectedDriver && selectedDriver.driverBalance ? selectedDriver.driverBalance : "",
        driver_payout_amount: amount ? amount : "",
        driver_payout_reason: reason ? reason : "",
        bank_account_id: finalBank && finalBank[0] && finalBank[0].id ? finalBank[0].id : ""
      });

    }

    if (toggleRightSideBar) {
      toggleRightSideBar(entityData)
    }
  }
  const handleAddBankClose = () => {
    setAddBankDetails(false);

  }
  const handleAddBankSave = (status) => {
    if (status) {
      handleSuccessOpen()
      setTimeout(() => {
        handleSuccessClose()
      }, 3000);
    } else {
      handleFailureOpen()
      setTimeout(() => {
        handleFailureClose()
      }, 3000);
    }
    loadBanKList()
    setAddBankDetails(false)
  }
  const handleAddBankOpen = () => {
    setAddBankDetails(true);
    trackDwebEvent('Dweb Driver payout add bank account initiated', {
      driver_name: selectedDriver && selectedDriver.name ? selectedDriver.name : "",
      driver_id: selectedDriver && selectedDriver.id ? selectedDriver.id : "",
      driver_balance: selectedDriver && selectedDriver.driverBalance ? selectedDriver.driverBalance : ""
    });
  }
  //Select Bank
  const handleSelectBankOpen = () => {
    setSelectBank(true)
  }
  const handleSelectBankClose = () => {
    setSelectBank(false)
  }
  const handleSelectBankSave = (status) => {
    if (status) {
      loadBanKList()
    }
    setSelectBank(false)
  }

  const handleCustomPGClose = () => {
    setCustomPGOpen(false);
    setOrderRequestData(null);
    setCashFreeOrderData(null);
    //handleClose(true)
  }
  const handleCustomPGConfirm = () => {
    setCustomPGOpen(false);
    setOrderRequestData(null);
    setCashFreeOrderData(null);
    handleClose(true)
  }
  const handleSuccessOpen = () => {
    setSuccessCreation(true)
  }
  const handleSuccessClose = () => {
    setSuccessCreation(false)
  }
  const handleFailureOpen = () => {
    setFailureCreation(true)
  }
  const handleFailureClose = () => {
    setFailureCreation(false)
  }
  const handleSave = () => {
    if (handleSubmit) {
      handleSubmit()
    }
    //dispatchChatView(true);
  }
  const handleDriverSelect = (driver) => {
    if (driver && driver.id) {
      trackDwebEvent('Dweb Online Payments driver selected', {
        driver_name: driver && driver.name ? driver.name : "",
        driver_id: driver && driver.id ? driver.id : "",
        driver_balance: driver && driver.driverBalance ? driver.driverBalance : ""
      });
      let reqData = {
        type: "DRIVER",
        id: driver.id
      }


      dispatchGetUserDetails(
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log('Pay Driver Side Bar Dweb', 'Fetch User Details Successfull');
            dispatchGetOnlinePaymentsConfig(
              (data) => {
                if (data && data.status && data.status.code == 200) {
                  logger.log('Pay Driver Side Bar Dweb', 'Get Online Payments Config Successfull');
                  dispatchFetchBankDetails(reqData, (response) => {
                    if (response && response.status && response.status.code == 200 && response.response && response.response.length > 0) {
                      trackDwebEvent('Dweb Driver payout form page', {
                        driver_id: driver && driver.id ? driver.id : "",
                        driver_name: driver && driver.name ? driver.name : "",
                        driver_balance: driver && driver.driverBalance ? driver.driverBalance : ""
                      });
                      setBankList(response.response);
                    }
                    setSelectedDriver(driver);
                  }, () => {

                  })
                }
              },
              () => {
                logger.log('Pay Driver Side Bar Dweb', 'Get Online Payments Config Failed');
              }
            );
          }
        },
        () => {
          logger.log('Pay Driver Side Bar Dweb', 'Fetch User Details Failed');
        }
      );
    }
  }
  const validate = values => {

    const errors = {};
    let transactionLimit = 0;

    if (!values.amount) {
      errors.amount = 'Amount Required';
    }
    if (!values.reason) {
      errors.reason = 'Reason Required';
    }
    if (values.amount && !validNumberCheck(values.amount)) {
      errors.amount = 'Invalid Amount';
    }

    if (userInfo) {
      if (!userInfo.isKYCVerified && !userInfo.isPaymentsWhitelisted) {
        transactionLimit = configInfo && configInfo.transactionLimit ? configInfo.transactionLimit : 0;
      } else if (userInfo.isPaymentsWhitelisted && !userInfo.isKYCVerified) {
        transactionLimit = configInfo && configInfo.whiteListedUserTransactionLimit ? configInfo.whiteListedUserTransactionLimit : 0;
      } else if (userInfo.isKYCVerified) {
        transactionLimit = configInfo && configInfo.KycUserTransactionLimit ? configInfo.KycUserTransactionLimit : 0;
      }
    }


    /*if (values.amount && validNumberCheck(values.amount) && Number(replaceCommas(values.amount)) > Number(transactionLimit)) {
      errors.amount = 'Amount cannot be greater than ' + numberFormat(transactionLimit);
    }*/


    return errors;
  };

  let initialValues = {
    amount: amount,
    reason: reason
  };

  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);

    if (selectedDriver && selectedDriver.contactNumber) {
      handlePayNow(values);
    } else {
      setAddPhoneNumber(true);
    }

  };

  const addPhoneNumberDialogClose = () => {
    setAddPhoneNumber(false);
  }

  const addPhoneNumberDialogConfirm = () => {
    setAddPhoneNumber(false);
    handlePayNow();
  }

  const handlePayNow = () => {
    let finalBank = bankList.filter(v => v && v.is_default);
    if (finalBank && finalBank.length > 0 && finalBank[0] && finalBank[0].id) {
      let reqData = {
        "bankId": `${finalBank[0].id}`,
        "payerType": "USER",
        "payeeType": "DRIVER",
        "payments": [
          {
            "amount": Number(replaceCommas(amount))
          }
        ],
        "payerId": user.userInfo.entityId,
        "description": reason,
        "payeeId": `${selectedDriver && selectedDriver.id ? selectedDriver.id : ""}`,
        "paymentView": "web_v2",
        "returnUrl": `${window.location.href}`
      }
      dispatchGetPaymentInitiate(reqData, (data) => {
        if (data && data.status && data.status.code == 200 && data.response) {
          setOrderRequestData({
            ...reqData,
            orderAmount: Number(replaceCommas(amount)),
            selectedDriver:selectedDriver,
            finalBank:finalBank[0],
            returnUrl: `${window.location.href}`
          });
          setCashFreeOrderData(data.response);
          setCustomPGOpen(true)
          //handleClose(true)
      }else{
        handleClose(true)
      }
        /*if (data && data.status && data.status.code == 200 && data.response && data.response.paymentLink) {
          trackDwebEvent('Dweb Driver payout form page successful', {
            driver_id: selectedDriver && selectedDriver.id ? selectedDriver.id : "",
            driver_name: selectedDriver && selectedDriver.name ? selectedDriver.name : "",
            driver_balance: selectedDriver && selectedDriver.driverBalance ? selectedDriver.driverBalance : "",
            driver_payout_amount: amount ? amount : "",
            driver_payout_reason: reason ? reason : "",
            bank_account_id: finalBank[0].id
          });
          window.location.href = data.response.paymentLink;
        }
        handleClose(reqData);*/
      }, (data) => {
        trackDwebEvent('Dweb Driver payout form page failed', {
          driver_id: selectedDriver && selectedDriver.id ? selectedDriver.id : "",
          driver_name: selectedDriver && selectedDriver.name ? selectedDriver.name : "",
          driver_balance: selectedDriver && selectedDriver.driverBalance ? selectedDriver.driverBalance : "",
          driver_payout_amount: amount ? amount : "",
          driver_payout_reason: reason ? reason : "",
          bank_account_id: finalBank[0].id,
          error_reason: data && data.status && data.status.message ? data.status.message : ""
        });
        handleClose(reqData)
      })
    }
  }

  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={classes.titleV2}>Amount to Send*</div>
            <AmountInput
              // label="Truck Hire Cost"
              placeholder="Enter a amount"
              name="amount"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setAmount(e.target.value)
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                className: classes.newInput,
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        inline: false,
        field: (
          <>
            <div className={classes.titleV2}>Reason for Sending Money*</div>
            <TextInputState
              // label="Truck Hire Cost"
              placeholder="Enter a reason"
              name="reason"
              margin="none"
              fullWidth={true}
              variant="outlined"
              size="small"
              onChange={(e) => {
                setReason(e.target.value)
              }}
              InputProps={{
                className: classes.newInput,
              }}
              required={true}
            />
          </>
        ),
      },
      {
        size: 12,
        visible: bankList && bankList.length == 0,
        field: (
          <>
            <Button className={classes.addBankDetailsButton} variant='outlined' onClick={() => handleAddBankOpen()}>
              <AddIcon /> Add Driver’s Bank Account
            </Button>
          </>
        ),
      },
      {
        size: 12,
        visible: bankList && bankList.length > 0,
        field: (
          <>
            <div className={classes.titleV2}>Account Details</div>
            {bankList && bankList && bankList.length > 0 && bankList.filter(v => v && v.is_default).map((bank) => {
              return (
                <div className={classes.bankDetailsDiv}>
                   {bank && bank.acc_type && bank.acc_type == 'BANK'&&<><Grid container spacing={2}>
                    <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>Name</Typography>
                        <Typography className={classes.valueTxt}>
                          {bank && bank.acc_holder_name ? bank.acc_holder_name.toLowerCase() : ""}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>Account Number</Typography>
                        <Typography className={classes.valueTxt}>{bank && bank.acc_number ? bank.acc_number : ""}</Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4} className={classes.alignEnd}>
                      {bank && bank.broker_verification_status && <><VerifiedBankAccount />
                        <Typography className={classes.verifiedAccount}>Verified Account</Typography></>}
                      {bank && !bank.broker_verification_status && <><UnVerifiedBankAccount />
                        <Typography className={classes.unVerifiedAccount}>Verification Failed</Typography></>}
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>Bank Name</Typography>
                        <Typography className={classes.valueTxt1}>
                          {bank && bank.bank_name ? bank.bank_name.toLowerCase() : ""}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.bankValueDiv}>
                        <Typography className={classes.subTitleTxt}>IFSC Code</Typography>
                        <Typography className={classes.valueTxt1}>{bank && bank.ifsc_code ? bank.ifsc_code : ""}</Typography>
                      </div>
                    </Grid>
                    <Grid item xs={4} className={classes.alignEnd} >
                      <Button className={classes.changeButton} variant='outlined' onClick={() => handleSelectBankOpen()}>
                        Change
                      </Button>
                    </Grid>
                  </Grid></>}
                  {bank && bank.acc_type && bank.acc_type == 'UPI'&&<>
                      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <div className={classes.bankValueDiv}>
                              <Typography className={classes.subTitleTxt}>UPI ID</Typography>
                              <Typography className={classes.valueTxtUPI}>
                                  {bank && bank.upi_address ? bank.upi_address : ""}
                              </Typography>
                          </div>
                          <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                            {bank && bank.broker_verification_status && <><VerifiedBankAccount />
                                &nbsp;
                                <Typography className={classes.verifiedAccount}>Verified Account</Typography></>}
                            {bank && !bank.broker_verification_status && <><UnVerifiedBankAccount />
                                &nbsp;
                                <Typography className={classes.unVerifiedAccount}>Verification Failed</Typography></>}
                                &nbsp;&nbsp;
                            <Button className={classes.changeButton} variant='outlined' onClick={() => handleSelectBankOpen()}>
                                Change
                            </Button>
                          </Box>
                      </Box>
                    </>}
                </div>)
            }
            )}
          </>
        ),
      }
    ]
  }
  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={rightSideBarOpen}
      ModalProps={{
        keepMounted: false,
        className: classes.modal,
        BackdropProps: {
          className: classes.backdrop
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        //onBackdropClick: handleClose
      }}
      classes={{
        paper: classes.transactionDetailsDrawer
      }}
    >
      <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} siderBarType={'truckBook'} onClose={handleClose}>
        <div className={classes.titleDiv}>
          <div className={classes.divTitle}>
            {!fromSingleDriver &&
              <>
                {selectedDriver ? "Pay Online" : 'Select a Driver'}
              </>
            }
            {fromSingleDriver &&
              <>
                Pay Online
              </>
            }
          </div>
          {/* <div className={classes.divSecTitle}>
                  {sideBarSecondaryTitle ? sideBarSecondaryTitle : 'Title'}
            </div> */}
        </div>
      </SideBarDialogTitle >
      <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >
        {!fromSingleDriver &&
          <>
            {driverLedgerData && driverLedgerData.length == 0 && <div className={classes.emptyStateDiv}>
              <img src={`${process.env.PUBLIC_URL}/assets/images/driver-list-empty-state.svg`} alt="Empty State Image" />
              <Typography className={classes.emptyTxt}>Add Drivers to Send Money Online</Typography>
            </div>}
            {!selectedDriver && driverLedgerData && driverLedgerData.length > 0 && <div >
              <div className={classes.search}>
                {!driverSearchTxt && <div className={classes.searchIcon}>
                  <SearchIcon className={classes.sicon} />
                </div>}
                {driverSearchTxt && <div className={classes.closeIcon} onClick={(e) => { setDriverSearchTxt("") }}>
                  <CloseIcon className={classes.sicon} />
                </div>}
                <InputBase
                  placeholder="Search for Driver"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  onChange={(e) => { setDriverSearchTxt(e.target.value) }}
                  inputProps={{ 'aria-label': 'search' }}
                />
              </div>
              <div className={classes.listingDiv}>
                {/* <div className={classes.subTitleSec} >
                  <Typography className={classes.subTitleTxt}>Driver Name</Typography>
                  <Typography className={classes.subTitleTxt}>Balance</Typography>
              </div> */}
                {driverLedgerData && driverLedgerData.length > 0 && driverLedgerData.filter(driver => {
                  return driver && driver.name.toLowerCase().indexOf(driverSearchTxt.toLowerCase()) >= 0;
                }).map((driver) => {
                  return (
                    <div className={classes.driverDiv} onClick={(e) => { handleDriverSelect(driver) }}>
                      <div className={classes.nameDiv}>
                        <Typography className={classes.listDriverName}>
                          <Highlighter
                            highlightClassName={classes.highlight}
                            searchWords={[driverSearchTxt]}
                            autoEscape={true}
                            textToHighlight={driver && driver.name ? driver.name : ""}
                          />
                        </Typography>
                        <Typography className={driver.driverBalance > 0 ? classes.listDriverBalancePositive :driver.driverBalance ==0?classes.listDriverBalanceZero :classes.listDriverBalanceNegative}><span className={classes.driverName}>{driver && (driver.driverBalance || driver.driverBalance == 0) ? numberFormat(driver.driverBalance) : ""}</span><span className={classes.balance}>Balance</span></Typography>
                      </div>
                      <div className={classes.balanceDiv} >
                        <Typography className={classes.pay}>Pay</Typography>
                        <RightArrow className={classes.listRightIcon} />
                      </div>
                    </div>)
                })}
              </div>
            </div>}
          </>
        }

        {selectedDriver && <div>
          <div className={classes.driverDetailsDiv}>
            <div className={classes.subTitleSec} >
              <Typography className={classes.subTitleTxt}>Driver Name</Typography>
              <Typography className={classes.subTitleTxt}>Balance</Typography>
            </div>
            <div className={classes.infoDiv}>
              <div className={classes.nameDiv}>
                <Typography className={classes.listDriverName}>
                  {selectedDriver && selectedDriver.name ? selectedDriver.name : ""}
                </Typography>
              </div>
              <div className={classes.balanceDiv} >
                <Typography className={selectedDriver && selectedDriver.driverBalance > 0 ? classes.listDriverBalancePositive : classes.listDriverBalanceNegative}>{selectedDriver && (selectedDriver.driverBalance || selectedDriver.driverBalance == 0) ? numberFormat(selectedDriver.driverBalance) : ""}</Typography>
              </div>
            </div>
          </div>
          <Form
            onSubmit={onSubmit}
            //keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit; formValues = values; return (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid container alignItems="flex-start" spacing={3}>
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx} className={classes.ptV1}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </form>
              )
            }}
          />
        </div>}
      </SideBarDialogContent>
      <SideBarDialogActions className={classes.sideBarActions} >
        {driverLedgerData && driverLedgerData.length == 0 && !fromSingleDriver &&
          <>
            <Button variant="contained" className={classes.addCta} onClick={handleAddDriverOpen} >
              Add Driver
            </Button>
          </>}
        {!selectedDriver && driverLedgerData && driverLedgerData.length > 0 && <>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
            Close
          </Button>
        </>}
        {selectedDriver &&
          <div className={classes.divActionsPayment}>
            {!fromSingleDriver &&
              <Button variant="contained" className='modal-close-cta' onClick={() => { setSelectedDriver(null); setDriverSearchTxt("") }} >
                Back
              </Button>
            }
            {fromSingleDriver &&
              <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
                Close
              </Button>
            }
            {/* <Button disabled={Object.keys(validate(initialValues)).length != 0 || !bankList || bankList.filter(v => v && v.is_default && v.broker_verification_status).length < 1} variant="contained" className={classes.payNowButton} onClick={event => submit(event)} >
              Pay Now
            </Button> */}
          </div>
        }
      </SideBarDialogActions>
      {addBankDetails && <AddBankDetailsDialog type={"DRIVER"} selectedData={selectedDriver} open={addBankDetails} onClose={handleAddBankClose} onSave={handleAddBankSave} />}
      {selectBank && <BankDetailsSelectionDialog type={"DRIVER"} selectedData={selectedDriver} open={selectBank} onClose={handleSelectBankClose} onSave={handleSelectBankSave} />}
      {successCreation && <SuccessDialog open={successCreation} title={"Account Verified Successfully"} onClose={handleSuccessClose} />}
      {failureCreation && <FailureDialog open={failureCreation} title={"Account Verification Failed"} subTitle={"Please Re-Check the Bank Account details"} onClose={handleFailureClose} />}
      {addPhoneNumber && <AddPhoneNumberDialog open={addPhoneNumber} type={"driver"} onClose={addPhoneNumberDialogClose} onConfirm={addPhoneNumberDialogConfirm} entityData={selectedDriver} calledFromFlow={"onlinePaymentDriver"} />}
      {addDriverOpen && <AddDriver open={addDriverOpen} defaultName={null} defaultNumber={null} onClose={handleAddDriverClose} type={'driver'} onConfirm={handleDriverSave} fromTrip={true} />}
      {customPGOpen && <DwebPaymentGateWayDialog open={customPGOpen} orderRequestData={orderRequestData} cashFreeOrderData={cashFreeOrderData} onClose={handleCustomPGClose} onSave={handleCustomPGConfirm} />}
    </Drawer >
  );
};

PayDriverSideBar.propTypes = {
  rightSideBarOpen: PropTypes.bool,
  toggleRightSideBar: PropTypes.func
};
const PayDriverSideBarWithRouter = withRouter(PayDriverSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value)),
  dispatchFetchAllDrivers: (data, onSuccess, onFailure) => (dispatch(getDriverLedgerV2(data, onSuccess, onFailure))),
  dispatchFetchBankDetails: (data, onSuccess, onFailure) => (dispatch(getBankDetails(data, onSuccess, onFailure))),
  dispatchGetPaymentLink: (data, onSuccess, onFailure) => (dispatch(getPaymentLink(data, onSuccess, onFailure))),
  dispatchGetOnlinePaymentsConfig: (onSuccess, onFailure) => { dispatch(onlinePaymentsConfig(onSuccess, onFailure)) },
  dispatchGetUserDetails: (onSuccess, onFailure) => { dispatch(getUserDetails(onSuccess, onFailure)) },
  dispatchGetPaymentInitiate: (data, onSuccess, onFailure) => (dispatch(getPaymentInitiate(data, onSuccess, onFailure))),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayDriverSideBarWithRouter);
